import { crawlerFilterGroups } from './crawlerFilterGroups';
import { crawlerLabel } from './crawlerLabels';
import DateRangeFilter from './DateRangeFilter';
import type { IncidentListParams } from './incidentListParams';
import MultiSelectFilter from './MultiSelectFilter';
import SearchFilter from './SearchFilter';
import type { IncidentListFilterPatch } from './useIncidentListParams';

type IncidentFiltersProps = {
  params: IncidentListParams;
  onChange: (patch: IncidentListFilterPatch) => void;
};

const crawlersChosen = (selected: readonly string[]): string => {
  if (selected.length === 0) return 'All crawlers';
  if (selected.length === 1) return crawlerLabel(selected[0]);

  return `${selected.length} crawlers`;
};

function IncidentFilters({ params, onChange }: IncidentFiltersProps) {
  return (
    <div className="diagnostics-filters" role="group" aria-label="Incident filters">
      <SearchFilter value={params.search} onSubmit={(search) => onChange({ search })} />
      <DateRangeFilter dateStart={params.dateStart} dateEnd={params.dateEnd} onChange={(range) => onChange(range)} />
      <MultiSelectFilter
        name="crawler"
        label="crawler"
        groups={crawlerFilterGroups(params.crawlers)}
        selected={params.crawlers}
        onChange={(crawlers) => onChange({ crawlers })}
        summaryOf={crawlersChosen}
      />
    </div>
  );
}

export default IncidentFilters;
